import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function Driverslist({ result, clearSearch }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
        Drivers {result.drivers?.length > 0 && `(${result.drivers.length})`}
      </Typography>
      <Box
        sx={{
          marginTop: "5px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {result.drivers?.length > 0 ? (
          result.drivers.map((obj, i) => {
            return (
              <Box
                onClick={() => {
                  navigate("/driver-detail", {
                    state: { selectedDriver: obj },
                  });
                  clearSearch();
                }}
                sx={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#673C8E0F",
                  fontWeight: 700,
                  color: "black",
                  "&:active": {
                    backgroundColor: "#ddd0e9", // new background on hover
                  },
                }}
              >
                {obj.driverID}
              </Box>
            );
          })
        ) : (
          <Typography
            sx={{ fontWeight: 700, fontSize: "14px", color: "black" }}
          >
            No Results
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default Driverslist;
